export default __webpack_public_path__ + "static/media/disable-tree-table-icon.f0c60086.svg";